import React, { createContext, useContext, useMemo } from 'react';
import { Grab } from 'baseui/icon';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as S from './styles';
const SortableItemContext = createContext({
  attributes: {},
  listeners: undefined,
  ref() {}
});
const SortableItem = ({
  children,
  id
}) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition
  } = useSortable({
    id
  });
  const context = useMemo(() => ({
    attributes,
    listeners,
    ref: setActivatorNodeRef
  }), [attributes, listeners, setActivatorNodeRef]);
  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition
  };
  return <SortableItemContext.Provider value={context}>
      <S.SortableContainer ref={setNodeRef} style={style} tabindex="0">
        <DragHandle />
        {children}
      </S.SortableContainer>
    </SortableItemContext.Provider>;
};
const DragHandle = () => {
  const {
    attributes,
    listeners,
    ref
  } = useContext(SortableItemContext);
  return <button {...attributes} {...listeners} ref={ref}>
      <Grab size={'24px'} />
    </button>;
};
export default SortableItem;